import React from 'react';
import RevenueChart from '../../components/RevenueChart';

function AnalyticsPage() {
    return (
        <div className="p-2 sm:p-3">
            <RevenueChart />
        </div>
    );
}

export default AnalyticsPage;
